webpackJsonp([114276838955818,60335399758886],{

/***/ 153:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(332);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(153);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 auto;\n  max-width: ', ';\n'], ['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 auto;\n  max-width: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 1px solid ', ';\n  padding: 1em 0 2em;\n  margin: 0 1.5em;\n'], ['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 1px solid ', ';\n  padding: 1em 0 2em;\n  margin: 0 1.5em;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  padding: .25em 0;\n  width: 100%;\n  @media screen and (min-width: ', ') {\n    width: auto;\n  }\n  a {\n    font-weight: 600;\n    transition: all .2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n    &:visited {\n      color: ', ';\n    }\n  }\n'], ['\n  display: inline-block;\n  padding: .25em 0;\n  width: 100%;\n  @media screen and (min-width: ', ') {\n    width: auto;\n  }\n  a {\n    font-weight: 600;\n    transition: all .2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n    &:visited {\n      color: ', ';\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  max-width: 100px;\n'], ['\n  max-width: 100px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.footer(_templateObject, function (props) {
	  return props.theme.sizes.maxWidth;
	});
	
	var List = _styledComponents2.default.ul(_templateObject2, function (props) {
	  return props.theme.colors.secondary;
	});
	
	var Item = _styledComponents2.default.li(_templateObject3, function (props) {
	  return props.theme.responsive.small;
	}, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.theme.colors.highlight;
	}, function (props) {
	  return props.theme.colors.base;
	});
	
	var Wordmark = _styledComponents2.default.img(_templateObject4);
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      List,
	      null,
	      _react2.default.createElement(
	        Item,
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.contentful.com/', rel: 'nofollow', target: '_blank' },
	          _react2.default.createElement(Wordmark, { src: 'https://images.contentful.com/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg', alt: 'Powered by Contentful' })
	        )
	      ),
	      _react2.default.createElement(
	        Item,
	        null,
	        'Site theme by ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/ryanwiemer', target: '_blank' },
	          '@ryanwiemer'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  width: 100%;\n  padding: 1.5em 0;\n'], ['\n  background: ', ';\n  width: 100%;\n  padding: 1.5em 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: ', ';\n  margin: 0 auto;\n  padding: 0 1.5em;\n\n  ul {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  li {\n    display: inline-block;\n    margin-left: 1em;\n    &:first-child {\n      position: relative;\n      margin: 0;\n      flex-basis: 100%;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    color: DarkGray;\n    font-weight: 600;\n    transition: all .2s;\n    border-bottom: 2px solid ', ';\n    &:hover {\n      color: white;\n    }\n  }\n'], ['\n  width: 100%;\n  max-width: ', ';\n  margin: 0 auto;\n  padding: 0 1.5em;\n\n  ul {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  li {\n    display: inline-block;\n    margin-left: 1em;\n    &:first-child {\n      position: relative;\n      margin: 0;\n      flex-basis: 100%;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    color: DarkGray;\n    font-weight: 600;\n    transition: all .2s;\n    border-bottom: 2px solid ', ';\n    &:hover {\n      color: white;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (props) {
	  return props.theme.colors.base;
	});
	var Nav = _styledComponents2.default.nav(_templateObject2, function (props) {
	  return props.theme.sizes.maxWidth;
	}, function (props) {
	  return props.theme.colors.base;
	});
	
	var activeLinkStyle = {
	  color: 'white'
	};
	
	var Menu = function Menu() {
	  return _react2.default.createElement(
	    Header,
	    null,
	    _react2.default.createElement(
	      Nav,
	      null,
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', exact: true, activeStyle: activeLinkStyle },
	            'Home'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about/', activeStyle: activeLinkStyle },
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact/', activeStyle: activeLinkStyle },
	            'Contact'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.6c9cb8e2.ico";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(47);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _global = __webpack_require__(336);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _theme = __webpack_require__(337);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Menu = __webpack_require__(327);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(325);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _favicon = __webpack_require__(439);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function Template(_ref) {
	  var children = _ref.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { charSet: 'utf-8' }),
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' }),
	      _react2.default.createElement('link', { rel: 'icon', href: _favicon2.default }),
	      _react2.default.createElement('meta', { name: 'description', content: _siteConfig2.default.siteDescription }),
	      _react2.default.createElement('meta', { property: 'og:title', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_US' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: _siteConfig2.default.siteUrl })
	    ),
	    _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Menu2.default, null),
	        children(),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  /* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n  */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n\n  body {\n    line-height: 1;\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  blockquote, q {\n    quotes: none;\n  }\n\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: \'\';\n    content: none;\n  }\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    background: white;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    font-variant-ligatures: none;\n    -webkit-font-variant-ligatures: none;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n'], ['\n  /* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n  */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n\n  body {\n    line-height: 1;\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  blockquote, q {\n    quotes: none;\n  }\n\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: \'\';\n    content: none;\n  }\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    background: white;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    font-variant-ligatures: none;\n    -webkit-font-variant-ligatures: none;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;\n    font-weight: 400;\n    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject);

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var theme = {
	  colors: {
	    base: '#121212', // Black
	    secondary: '#e9e9e9', // Medium Gray
	    tertiary: '#f3f3f3', // Light Gray
	    highlight: '#5b8bf7' // Light Blue
	  },
	  sizes: {
	    maxWidth: '1200px',
	    maxWidthCentered: '650px'
	  },
	  responsive: {
	    small: '35em',
	    medium: '50em',
	    large: '70em'
	  }
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-049436ad4de48f0f6abc.js